// brazilV2Language.ts
// ─── Astria Brazil v2 — self-contained EN/PT language toggle ──────────────
// Scoped entirely to this feature — does NOT touch the app-wide i18next
// setup (src/i18n.ts) or any other country lane. Persists only the Brazil
// V2 screen's own language choice, independent of the account's global
// `preferredLanguage`.
import { useCallback, useEffect, useState } from "react";

export type BrazilV2Lang = "en" | "pt";

const STORAGE_KEY = "astriaBrazilV2Lang";

export function getStoredBrazilV2Lang(): BrazilV2Lang {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "pt") return stored;
  } catch {
    // localStorage unavailable — fall through to default
  }
  return "pt";
}

export function useBrazilV2Language(): [
  BrazilV2Lang,
  (lang: BrazilV2Lang) => void,
] {
  const [lang, setLangState] = useState<BrazilV2Lang>(getStoredBrazilV2Lang);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {
      // ignore
    }
  }, [lang]);

  const setLang = useCallback((next: BrazilV2Lang) => {
    setLangState(next);
  }, []);

  return [lang, setLang];
}
